/* eslint-disable react/no-unused-state */
import React, { Component } from 'react'
import styled from 'styled-components'

const urlContactSL = 'https://www.seloger.com/contact.html?query=legal#formulaire'
const urlCguSL = 'https://www.seloger.com/CGU_politique_de_confidentialite.html'
const urlContactLI = 'https://www.logic-immo.com/contactez-nous'
const urlCguLI = 'https://www.logic-immo.com/cgu-et-politique-de-confidentialite.html'

const RgpdStyled = styled.p`
  font-size: 0.75rem;
  text-align: justify;

  a {
    color: #262626;
  }
`

class Rgpd extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
    }
    this.handleClick = this.handleClick.bind(this)
  }

  handleClick(e) {
    e.preventDefault()
    this.setState(prevState => ({ display: !prevState.display }))
  }

  render() {
    const { display } = this.state
    const { isLogicImmo } = this.props
    return (
      <RgpdStyled>
        Vos informations (dont celles relatives à votre navigation sur {isLogicImmo ? 'Logic-Immo.com' : 'SeLoger'}) sont traitées par Digital Classifieds France et transmises au
        professionnel de l’immobilier que vous souhaitez contacter afin de gérer votre demande. Pour exercer vos droits conformément à la loi « informatique et libertés »,&nbsp;
        <a onClick={this.handleClick} href="mentions_legales" target="_blank" rel="noopener noreferrer">
          cliquez ici
        </a>
        &nbsp;
        {display && (
          <span>
            . Vous pouvez accéder aux données vous concernant, les faire rectifier ou demander leur effacement. Vous disposez également d’un droit d’opposition, d’un droit à la
            portabilité et d’un droit à la limitation du traitement des données qui vous concernent que vous pouvez exercer en vous adressant à : SeLoger / Digital Classifieds
            France - 65 Rue Ordener, 75880 Paris Cedex 18 ou en&nbsp;
            <a href={isLogicImmo ? urlContactLI : urlContactSL} target="_blank" rel="noopener noreferrer">
              cliquant ici.
            </a>
            &nbsp; Pour plus d’informations, vous pouvez également consulter nos&nbsp;
            <a href={isLogicImmo ? urlCguLI : urlCguSL} target="_blank" rel="noopener noreferrer">
              « CGU - Politique de Confidentialité. »
            </a>
          </span>
        )}
      </RgpdStyled>
    )
  }
}

Rgpd.defaultProps = {
  isLogicImmo: false,
}
export default Rgpd
